<template>
    <b-modal v-model="show" title="БИНО ТУРИ">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="col-12">
                        <div>
                            <label>{{$t("accounting.account.date")}}</label>
                            <datepicker
                                    class="form-control"
                                    format="dd/MM/yyyy"
                                    v-model="data.paymentDocumentDate"
                                    :clear-button="true"
                            ></datepicker>
                        </div>
                        <label>{{$t("accounting.account.totalAmount")}}</label>
                        <numeric-input v-model="data.price" :precision="2" required></numeric-input>
                        <label>{{$t("accounting.account.number")}}</label>
                        <input type="text" class="form-control" id="paymentDocumentNumber"
                               name="paymentDocumentNumber"
                               v-model="data.paymentDocumentNumber" placeholder=" Раками"
                               required>

                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>

    import initFilterModel from '@/shared/filter';
    import Datepicker from 'vuejs-datepicker';
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';

    export default {
        name: "PaymentDocumentEditModal",
        components: {
            'b-modal': bModal,
            Datepicker,
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                filter: initFilterModel(),
                show: false,
                processing: false,
                numericTypes: numericTypes,
                data: {}
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {

                const vm = this;
                this.processing = true;
                if (this.data.price > 0 && this.data.paymentDocumentNumber != "" && this.data.paymentDocumentDate != "") {
                this.$http.post('/payment/documents/save', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('LegalAccountingAsset', {});
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
                } else {
                    vm.show = false;
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('accounting.accountMessages.error'),
                        type: 'error'
                    });
                    vm.processing = false;
                }

            }
        },
        created() {
            this.$eventBus.$on('showPaymentDocumentEditModal', (data) => {
                console.log(data);
                if (data) {
                    this.data = clone(data);
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>
